import React from 'react';
import PropTypes from 'prop-types';
import 'react-phone-input-2/lib/style.css';
import clsx from "clsx";
import DownloadIcon from "../../icons/DownloadIcon";

import styles from './UploadFile.module.scss';

export const UploadFileInput = React.forwardRef((props, ref) => {
  const {value, name, ...others} = props;
  return (
    <label
      className={clsx("px-4 py-2 rounded-lg shadow-lg tracking-wide border border-blue cursor-pointer", styles.container)}>
      <span className={clsx(styles.label, "flex justify-center items-center leading-normal")}>
        <DownloadIcon className="mr-1"/>
        Añadir archivo
      </span>
      <input type='file' style={{display: 'none'}} ref={ref} {...others} />
    </label>
  );
});

UploadFileInput.defaultProps = {
  help: '',
  placeholder: '',
};

UploadFileInput.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  help: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  className: PropTypes.string,
};

export default UploadFileInput;
